import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';
import Config from 'Config';

export const getProjectMergeStatus = createAsyncThunk(
  'projects/getProjectMergeStatus',
  async (_, { getState, rejectWithValue }) => {
    const state = getState();

    const selectedProjectId = state?.root?.project?.id;

    if (!selectedProjectId) {
      throw new Error('No project selected');
    }

    const apiPath = `projects/${selectedProjectId}/merge-status`;

    const request = {
      //url: `http://localhost:3001/${apiPath}`,
      url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
      host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
      path: apiPath,
      method: 'GET',
      region: Config.AWS_REGION,
      service: 'execute-api',
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const signedRequest = await createSignedRequest(request);

    let response;
    try {
      response = await axios(signedRequest);
    } catch (e) {
      return rejectWithValue({ errorMessage: e.response.data.message });
    }

    return response.data;
  }
);
